import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ConfirmacaoinscricaoComponent } from './pages/confirmacaoinscricao/confirmacaoinscricao.component';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { DocumentosComponent } from './pages/documentos/documentos.component';
import { FichainscricaoComponent } from './pages/fichainscricao/fichainscricao.component';
import { HomeComponent } from './pages/home/home.component';
import { AcompanhamentoComponent } from './pages/acompanhamento/acompanhamento.component';

const routes: Routes = [
  { path: 'confirmacaoinscricao', component: ConfirmacaoinscricaoComponent },
  { path: 'documentos', component: DocumentosComponent },
  { path: 'fichainscricao', component: FichainscricaoComponent },
  { path: 'acompanhamento', component :AcompanhamentoComponent},
  { path: 'home', component: HomeComponent },
  { path: '', redirectTo: 'home', pathMatch: 'prefix' },
  { path: '**',  component : NotfoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
